import { FormSection, Radio } from '@ksyos/design-system';
import type {
    BariPostNurseSpecialistReportData,
    BariPostNurseSpecialistReportVervolgstap,
} from '@common/validation/customControls/bariPost/bariPostNurseSpecialistReport/v1/bariPostNurseSpecialistReportSchemaV1';
import { bariPostNurseSpecialistReportVervolgstappen } from '@common/validation/customControls/bariPost/bariPostNurseSpecialistReport/v1/bariPostNurseSpecialistReportSchemaV1';
import { ProcessActivityAssetsDropzone } from '@frontend/components/pages/episodeCategory/customControls/processActivityAssets/ProcessActivityAssetsDropzone';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { RadioGroupFormGroup, TextAreaFormGroup } from '../../processActivityFormGroupFields';

export function BariPostNurseSpecialistReportEdit(): JSX.Element {
    const { onChange } = useProcessActivityEditContext<BariPostNurseSpecialistReportData>();

    return (
        <>
            <FormSection title="Verslag">
                <TextAreaFormGroup
                    fieldKey="verslag"
                    isRequired={true}
                    label="Verslag"
                    placeholder="Typ je verslag..."
                />
                <TextAreaFormGroup
                    fieldKey="hulpvraag"
                    label="Hulpvraag"
                    placeholder="Typ je hulpvraag..."
                />
                <TextAreaFormGroup
                    fieldKey="interventie"
                    label="Interventie"
                    placeholder="Typ je interventie..."
                />
                <ProcessActivityAssetsDropzone label="Bestand(en)" />
            </FormSection>

            <FormSection title="Vervolgstap">
                <RadioGroupFormGroup
                    fieldKey="vervolgstap"
                    isRequired={true}
                    label="Vervolgstap"
                    onChange={async (value) =>
                        onChange({ vervolgstap: value as BariPostNurseSpecialistReportVervolgstap })
                    }
                >
                    {bariPostNurseSpecialistReportVervolgstappen.map((value) => (
                        <Radio
                            key={value}
                            label={value}
                            value={value}
                        />
                    ))}
                </RadioGroupFormGroup>
            </FormSection>
        </>
    );
}
